var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingcart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_829_1928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.43587 25.6667C9.72454 25.6667 10.7692 24.622 10.7692 23.3333C10.7692 22.0447 9.72454 21 8.43587 21C7.14721 21 6.10254 22.0447 6.10254 23.3333C6.10254 24.622 7.14721 25.6667 8.43587 25.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1025 25.6667C21.3912 25.6667 22.4359 24.622 22.4359 23.3333C22.4359 22.0447 21.3912 21 20.1025 21C18.8139 21 17.7692 22.0447 17.7692 23.3333C17.7692 24.622 18.8139 25.6667 20.1025 25.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51036 15.3954C3.36597 14.6735 3.91815 14 4.65437 14H22.8082C23.5444 14 24.0966 14.6735 23.9522 15.3954L22.4607 22.853C22.1335 24.489 20.697 25.6666 19.0286 25.6666H8.43391C6.76553 25.6666 5.32907 24.489 5.00188 22.853L3.51036 15.3954ZM14.898 17.5C14.898 16.8556 15.4203 16.3333 16.0646 16.3333C16.709 16.3333 17.2313 16.8556 17.2313 17.5V22.1666C17.2313 22.811 16.709 23.3333 16.0646 23.3333C15.4203 23.3333 14.898 22.811 14.898 22.1666V17.5ZM11.398 16.3333C10.7536 16.3333 10.2313 16.8556 10.2313 17.5V22.1666C10.2313 22.811 10.7536 23.3333 11.398 23.3333C12.0423 23.3333 12.5646 22.811 12.5646 22.1666V17.5C12.5646 16.8556 12.0423 16.3333 11.398 16.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06445 10.5C2.06445 9.85568 2.58679 9.33334 3.23112 9.33334H24.2311C24.8755 9.33334 25.3978 9.85568 25.3978 10.5C25.3978 11.1443 24.8755 11.6667 24.2311 11.6667H3.23112C2.58679 11.6667 2.06445 11.1443 2.06445 10.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2234 4.32494C12.679 3.86933 12.679 3.13063 12.2234 2.67502C11.7678 2.21941 11.0291 2.21941 10.5735 2.67502L8.24015 5.00835C7.78453 5.46397 7.78453 6.20266 8.24015 6.65827C8.69576 7.11388 9.43445 7.11388 9.89006 6.65827L12.2234 4.32494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2401 4.32494C14.7845 3.86933 14.7845 3.13063 15.2401 2.67502C15.6958 2.21941 16.4345 2.21941 16.8901 2.67502L19.2234 5.00835C19.679 5.46397 19.679 6.20266 19.2234 6.65827C18.7678 7.11388 18.0291 7.11388 17.5735 6.65827L15.2401 4.32494Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_829_1928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.269531)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingcart);
export default __webpack_public_path__ + "static/media/shoppingcart.45a2504bee6152d3c9b5aff518dbbc63.svg";
export { ForwardRef as ReactComponent };